import React, { memo } from "react";
import { useSelector } from "react-redux";

const FallbackOdds = memo(() => (
  <ul>
    <li>
      <p className="match-back-medium disabled_sport">-</p>
      <p className="match-lay-medium disabled_sport">-</p>
    </li>
    <li>
      <p className="match-back-medium disabled_sport">-</p>
      <p className="match-lay-medium disabled_sport">-</p>
    </li>
    <li>
      <p className="match-back-medium disabled_sport">-</p>
      <p className="match-lay-medium disabled_sport">-</p>
    </li>
  </ul>
));

const RunnerRow = memo(({ runner, isMarketOpen }) => {
  const backPrice = isMarketOpen ? runner?.back?.[0]?.price || "-" : "-";
  const layPrice = isMarketOpen ? runner?.lay?.[0]?.price || "-" : "-";
  const disabledClass = !isMarketOpen ? "disabled_sport" : "";

  return (
    <li>
      <p className={`match-back-medium ${disabledClass}`}>{backPrice}</p>
      <p className={`match-lay-medium ${disabledClass}`}>{layPrice}</p>
    </li>
  );
});

const MatchOdds = ({ marketId }) => {
  const liveMarket = useSelector(
    (state) => state.dashboard?.matchFeed?.[marketId],
  );
  const isMarketOpen = liveMarket?.status === "OPEN";
  const runners = liveMarket?.payload?.runners || [];

  const displayRunners =
    runners.length === 2
      ? [runners[0], null, runners[1]]
      : [runners[0], runners[1], runners[2]];
  return (
    <ul>
      {displayRunners.map((runner, index) =>
        runner ? (
          <RunnerRow
            key={runner.id}
            runner={runner}
            isMarketOpen={isMarketOpen}
          />
        ) : (
          <li key={index}>
            <p className="match-back-medium disabled_sport">-</p>
            <p className="match-lay-medium disabled_sport">-</p>
          </li>
        ),
      )}
    </ul>
  );
};

export default memo(MatchOdds);
